import styles from './IconButton.module.css';

function IconButton({
  children,
  onClick,
  color = 'black',
  bgColor = 'transparent',
  disabled = false,
  size = "24px"
}) {

  const hoverColors = {
    "white": "var(--color-primary)",
    "transparent": "black",
  };

  return (
    <button className={[
      styles.button,
      disabled && styles.disabled
    ].filter(Boolean).join(" ")}
      style={{ color: color,
        width: size,
        height: size,
        '--clr': color,
        '--bg': bgColor,
        '--hover-bg': hoverColors[bgColor],
        '--hover-text': bgColor, 
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default IconButton;